<template>
  <div v-if="isOnboarding">
    <onboarding />
  </div>
</template>

<script>
import { defineAsyncComponent } from "vue";
import Onboarding from "./Onboarding.vue";
import LocalStorageFunc from "../helpers/localStorageFunc";
import { keyMapsMutation, keyMapsAction } from "../helpers/storeKeys";
import { LoginStates } from "../helpers/loginStateConstants";
import { clientPlatform } from "../config/apiEndpoints";
import fingerPrintInstance from "../store/storeInitializer/initialiseFingerprint";
import { collectData } from "../helpers/fingerPrintHelper";
// import {
//   VWO_HOMEPAGE_EXPERIMENT,
//   VWO_EXPERIMENT_VARIANTS,
//   VWO_VARIANT_HOMEPAGE_HEADER_NAME,
// } from "../config/vwoKeys";
import { initializeMoEngageTime } from "../helpers/moengageEvents";
import {
  loadAmplitudeUnsentEvents,
  EVENT_PAGEVIEW_LOGINPAGE,
} from "../helpers/analyticsEvents";
import { getVwoExperimentsPromiseArray } from "../helpers/vwoSetup";
import Utility from "../helpers/utility";
import { initializeMetaTime } from "../helpers/metaEvents";

export default {
  name: "LoginPage",
  components: {
    Onboarding,
    "welcome-login": defineAsyncComponent(() => import("./WelcomeLogin.vue")),
  },
  // props: ['dataResults'],
  data() {
    return {
      sessionDependedMethodsProcessed: false,
      clientPlatform,
    };
  },
  async mounted() {
    // let fetchedVwoData = {};
    // await Promise.all([...getVwoExperimentsPromiseArray()])
    //   .then((data) => {
    //     data.forEach((element) => {
    //       for (let key in element) {
    //         fetchedVwoData[key] = element[key];
    //       }
    //     });
    //     this.$store.commit(
    //       keyMapsMutation.UPDATE_VWO_EXPERIMENTS,
    //       fetchedVwoData
    //     );
    //   })
    //   .catch((errors) => {});

    loadAmplitudeUnsentEvents();

    const { getFPInstance } = fingerPrintInstance;
    collectData({ detector: getFPInstance() }).then((response) => {
      const payload = {
        detectorData: response,
      };
      this.$store.dispatch(keyMapsAction.SEND_FINGER_PRINT, payload);
    });

    if (!LocalStorageFunc.accessToken()) {
      this.$store.dispatch(keyMapsAction.ANONYMOUS_USER_API, {});
    } else {
      this.$store.commit(
        keyMapsMutation.UPDATE_CURRENT_LOGIN_STATE,
        LoginStates.welcomeLogin
      );
    }
    setTimeout(() => {
      initializeMoEngageTime();
      initializeMetaTime();
    }, 5000);

    Utility.osBackButtonFunc();
  },
  methods: {
    //
  },
  computed: {
    isSessionPresent() {
      let isSessionP = this.$store.state.Auth.isSessionPresent;
      if (
        isSessionP &&
        !this.sessionDependedMethodsProcessed &&
        LocalStorageFunc.isLoggedIn()
      ) {
        this.sessionDependedMethodsProcessed = true;
      }
      return isSessionP;
    },
    isOnboarding() {
      return clientPlatform == "Web"
        ? this.$store.state.Auth.currentLoginState === LoginStates.onboarding &&
            this.$store.state.Auth.showProfileDrawerModal
        : this.$store.state.Auth.currentLoginState === LoginStates.onboarding;
    },
    isWelcomeLogin() {
      return (
        this.$store.state.Auth.currentLoginState === LoginStates.welcomeLogin
      );
    },
  },
};
</script>
